<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Lead Form</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div>
              <md-layout md-gutter>
                <b-col md="3">
                  <label>
                    Type
                    <span class="error">*</span>
                  </label>
                  <model-list-select
                    isDisabled
                    class="ml-1"
                    :list="TypeList"
                    id="lead_type"
                    v-model="leadForm.lead_type"
                    option-value="value"
                    option-text="text"
                    placeholder="Select Type"
                  ></model-list-select>
                  <span class="error" v-if="!leadForm.lead_type">
                    {{ errorList.lead_type }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Shipment Type
                    <span class="error">*</span>
                  </label>

                  <multi-select
                    :options="shipmentTypeList"
                    :selected-options="shipmentType_items"
                    v-model="leadForm.lead_shipmentType"
                    placeholder="Select Shipment Type"
                    :multiple="true"
                    id="shipmentType"
                    @select="SelectMultishipmentTypeType"
                  ></multi-select>
                  <span class="error" v-if="!leadForm.lead_shipmentType">
                    {{ errorList.lead_shipmentType }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Module Type
                    <span class="error">*</span>
                  </label>
                  <multi-select
                    :options="moduelTypeList"
                    :selected-options="moduelType_items"
                    v-model="leadForm.lead_moduelType"
                    placeholder="Select Job Type"
                    :multiple="true"
                    @select="SelectMultimoduelType"
                  ></multi-select>
                  <span class="error" v-if="!leadForm.lead_moduelType">
                    {{ errorList.lead_moduelType }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Job Type
                    <span class="error">*</span>
                  </label>
                  <multi-select
                    :options="jobTypeList"
                    :selected-options="jobType_items"
                    v-model="leadForm.lead_jobType"
                    placeholder="Select Job Type"
                    :multiple="true"
                    @select="SelectMultijobType"
                  ></multi-select>

                  <span class="error" v-if="!leadForm.lead_jobType">
                    {{ errorList.lead_jobType }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Company Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_comp_name"
                    name="lead_comp_name"
                    v-model="leadForm.lead_comp_name"
                    @input="CheckClientName(leadForm.lead_comp_name)"
                    placeholder="Please Enter Company Name"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_comp_name">
                    {{ errorList.lead_comp_name }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Address
                    <span class="error">*</span>
                  </label>
                  <b-textarea
                    :formatter="capitalizeAll"
                    id="lead_address"
                    name="lead_address"
                    type="text"
                    v-model="leadForm.lead_address"
                    placeholder="Please Enter Address"
                  ></b-textarea>
                  <span class="error" v-if="!leadForm.lead_address">
                    {{ errorList.lead_address }}
                  </span>
                </b-col>
                <b-col md="6">
                  <table class="table table-sm table-bordered mt-2">
                    <tbody style="background: white">
                      <tr>
                        <th scope="col" style="width: 5px">SN.</th>
                        <th scope="col" style="width: 200px">Branch Address</th>
                        <th scope="col" style="width: 200px">Factory Address</th>
                        <th scope="col" style="width: 5px">
                          Actions
                          <b-button @click="addMultiAddress()" size="sm">
                            <i class="fa fa-plus-circle ml-1"></i>
                          </b-button>
                        </th>
                      </tr>
                      <tr v-for="(item, index) in AddressArr" :key="index">
                        <th scope="row">{{ index + 1 }}.</th>
                        <td>
                          <b-textarea
                            :formatter="capitalizeAll"
                            id="branch_address"
                            name="branch_address"
                            type="text"
                            v-model="item.branch_address"
                            :placeholder="`Please Enter Branch Address ${index + 1}`"
                          ></b-textarea>
                          <span
                            class="error"
                            v-if="item.branch_address_err ? true : false"
                            >{{ item.branch_address_err }}</span
                          >
                        </td>
                        <td>
                          <b-textarea
                            :formatter="capitalizeAll"
                            id="factory_address"
                            name="factory_address"
                            type="text"
                            v-model="item.factory_address"
                            :placeholder="`Please Enter Factory Address  ${index + 1}`"
                          ></b-textarea>
                          <span
                            class="error"
                            v-if="item.factory_address_err ? true : false"
                            >{{ item.factory_address_err }}</span
                          >
                        </td>
                        <td>
                          <b-button
                            v-if="index > 0"
                            size="sm"
                            @click="removeMultiAddress(index)"
                          >
                            <i class="fa fa-minus-circle" aria-hidden="true"></i>
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>

                <!-- New Questionnaire Section -->

                <b-col md="4" v-if="isSeaShipment">
                  <label>
                    Will the Lead deal with us for EXPORT / IMPORT OR Both?
                    <span class="error">*</span>
                  </label>
                  <model-list-select
                    class="ml-1"
                    :list="moduelTypeLeadList"
                    id="quest_export_import"
                    v-model="leadForm.quest_export_import"
                    option-value="value"
                    option-text="text"
                    placeholder="Select Lead deal Type"
                  ></model-list-select>
                  <span class="error" v-if="!leadForm.quest_export_import">
                    {{ errorList.quest_export_import }}
                  </span>
                </b-col>
                <b-col md="2" v-if="isSeaShipment">
                  <label>
                    CC
                    <span class="error">*</span>
                  </label>
                  <model-list-select
                    class="ml-1"
                    :list="CCList"
                    id="quest_cc"
                    v-model="leadForm.quest_cc"
                    option-value="val"
                    option-text="text"
                    placeholder="Select CC Type"
                  ></model-list-select>
                  <span class="error" v-if="!leadForm.quest_cc">
                    {{ errorList.quest_cc }}
                  </span>
                </b-col>

                <b-col md="2" v-if="isSeaShipment">
                  <label>
                    FF
                    <span class="error">*</span>
                  </label>
                  <model-list-select
                    class="ml-1"
                    :list="FFList"
                    id="quest_ff"
                    v-model="leadForm.quest_ff"
                    option-value="val"
                    option-text="text"
                    placeholder="Select FF Type"
                  ></model-list-select>
                  <span class="error" v-if="!leadForm.quest_ff">
                    {{ errorList.quest_ff }}
                  </span>
                </b-col>
                <b-col md="2" v-if="leadForm.quest_ff == '1'">
                  <label>Container Type</label>
                  <model-list-select
                    :list="$store.getters['common/getAllContainerTypeList']"
                    v-model="leadForm.quest_cont_type_id"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                  ></model-list-select>
                </b-col>
                <b-col md="2" v-if="leadForm.quest_ff == '1'">
                  <label>
                    Define monthly volume in Containers Wise or TEUS
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    v-model="leadForm.quest_monthly_volume"
                    placeholder="Enter monthly volume"
                    type="number"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.quest_monthly_volume">
                    {{ errorList.quest_monthly_volume }}
                  </span>
                </b-col>
                <b-col md="4" v-else-if="leadForm.quest_ff == '0'">
                  <label>
                    FF NA Reason
                    <span class="error">*</span>
                  </label>
                  <model-list-select
                    class="ml-1"
                    :list="FFNAReasonList"
                    id="ffOption"
                    v-model="leadForm.quest_ff_option"
                    option-value="val"
                    option-text="text"
                    placeholder="Select FF NA Reason"
                  ></model-list-select>

                  <span class="error" v-if="!leadForm.quest_ff_option">
                    {{ errorList.quest_ff_option }}
                  </span>
                </b-col>

                <b-col md="12">
                  <b>Add Multiple KAM</b>
                  <b-button @click="addMultiLead()" size="sm">
                    <i class="fa fa-plus-circle ml-1"></i>
                  </b-button>
                </b-col>
                <b-col
                  md="12"
                  v-for="(ld_item, ld_index) in multiLeadArr"
                  :key="ld_index"
                >
                  <b-col md="3">
                    <label>
                      Account {{ ld_index + 1 }}
                      <span class="error">*</span>
                    </label>
                    <model-list-select
                      :list="accountList"
                      id="lead_account"
                      v-model="ld_item.lead_account"
                      option-value="value"
                      option-text="text"
                      :placeholder="`Please Select Account Type ${ld_index + 1}`"
                    ></model-list-select>
                    <span class="error" v-if="!ld_item.lead_account">
                      {{ ld_item.lead_account_err }}
                    </span>
                  </b-col>
                  <b-col md="3">
                    <label>
                      Name {{ ld_index + 1 }}
                      <span class="error">*</span>
                    </label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="lead_name"
                      name="lead_name"
                      v-model="ld_item.lead_name"
                      :placeholder="`Please Enter Name ${ld_index + 1}`"
                      type="text"
                    ></b-form-input>
                    <span class="error" v-if="!ld_item.lead_name">
                      {{ ld_item.lead_name_err }}
                    </span>
                  </b-col>
                  <b-col md="3">
                    <label>
                      Email {{ ld_index + 1 }}
                      <span class="error">*</span>
                    </label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="lead_email"
                      name="lead_email"
                      v-model="ld_item.lead_email"
                      :placeholder="`Please Enter Email ID ${ld_index + 1}`"
                      type="email"
                    ></b-form-input>
                    <span class="error" v-if="!ld_item.lead_email">
                      {{ ld_item.lead_email_err }}
                    </span>
                  </b-col>
                  <b-col md="2">
                    <label>
                      Mobile {{ ld_index + 1 }}
                      <span class="error">*</span>
                    </label>
                    <b-form-input
                      :formatter="capitalizeAll"
                      id="lead_mobile"
                      name="lead_mobile"
                      v-model="ld_item.lead_mobile"
                      :placeholder="`Please Enter Mobile No. ${ld_index + 1}`"
                      type="number"
                    ></b-form-input>
                    <span class="error" v-if="!ld_item.lead_mobile">
                      {{ ld_item.lead_mobile_err }}
                    </span>
                  </b-col>
                  <b-col md="1">
                    <b-button
                      class="mt-5"
                      v-if="ld_index > 0"
                      size="sm"
                      @click="removeMultiLead(ld_index)"
                    >
                      <i class="fa fa-minus-circle" aria-hidden="true"></i>
                    </b-button>
                  </b-col>
                </b-col>

                <!-- <b-col md="3">
                  <label>
                    Branch Address
                    <span class="error">*</span>
                  </label>
                  <b-textarea
                    :formatter="capitalizeAll"
                    id="lead_branch_address"
                    name="lead_branch_address"
                    type="text"
                    v-model="leadForm.lead_branch_address"
                    placeholder="Please Enter Branch Address"
                  ></b-textarea>
                  <span class="error" v-if="!leadForm.lead_branch_address">
                    {{
                    errorList.lead_branch_address
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Factory Address
                    <span class="error">*</span>
                  </label>
                  <b-textarea
                    :formatter="capitalizeAll"
                    id="lead_factory_address"
                    name="lead_factory_address"
                    type="text"
                    v-model="leadForm.lead_factory_address"
                    placeholder="Please Enter Factory Address"
                  ></b-textarea>
                  <span class="error" v-if="!leadForm.lead_factory_address">
                    {{
                    errorList.lead_factory_address
                    }}
                  </span>
                </b-col>-->

                <b-col md="3">
                  <label>
                    Container Type
                    <span class="error"></span>
                  </label>
                  <model-list-select
                    :list="$store.getters['common/getAllContainerTypeList']"
                    v-model="AutoContainerType"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type"
                  ></model-list-select>

                  <md-chip
                    disabled
                    style="margin-top: 38px"
                    md-deletable
                    v-for="(type, index) in leadForm.lead_container_type"
                    :key="index"
                    @delete="deleteContainer(type)"
                    >{{ type }}</md-chip
                  >
                  <span class="error" v-if="!leadForm.lead_container_type">
                    {{ errorList.lead_container_type }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Commodity Exp
                    <span class="error"></span>
                  </label>
                  <b-textarea
                    :formatter="capitalizeAll"
                    id="lead_comodity_exp"
                    name="lead_comodity_exp"
                    type="text"
                    v-model="leadForm.lead_comodity_exp"
                    placeholder="Please Enter Commodity Exp"
                  ></b-textarea>
                  <span class="error" v-if="!leadForm.lead_comodity_exp">
                    {{ errorList.lead_comodity_exp }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Commodity Imp
                    <span class="error"></span>
                  </label>
                  <b-textarea
                    :formatter="capitalizeAll"
                    id="lead_comodity_imp"
                    name="lead_comodity_imp"
                    type="text"
                    v-model="leadForm.lead_comodity_imp"
                    placeholder="Please Enter Commodity Exp"
                  ></b-textarea>
                  <span class="error" v-if="!leadForm.lead_comodity_imp">
                    {{ errorList.lead_comodity_imp }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Remark
                    <span class="error"></span>
                  </label>
                  <b-textarea
                    :formatter="capitalizeAll"
                    id="lead_remark"
                    name="lead_remark"
                    type="text"
                    v-model="leadForm.lead_remark"
                    placeholder="Please Enter Remark"
                  ></b-textarea>
                  <span class="error" v-if="!leadForm.lead_remark">
                    {{ errorList.lead_remark }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    EXPORT MONTHLY VOLUME
                    <span class="error"></span>
                  </label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_exp_monthly_vol"
                    name="lead_exp_monthly_vol"
                    v-model="leadForm.lead_exp_monthly_vol"
                    placeholder="Please Enter EXPORT MONTHLY VOLUME"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_exp_monthly_vol">
                    {{ errorList.lead_exp_monthly_vol }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    IMPORT MONTHLY VOLUME
                    <span class="error"></span>
                  </label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_imp_monthly_vol"
                    name="lead_imp_monthly_vol"
                    v-model="leadForm.lead_imp_monthly_vol"
                    placeholder="Please Enter Lead Name"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_imp_monthly_vol">
                    {{ errorList.lead_imp_monthly_vol }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Exp/Imp POR
                    <span class="error"></span>
                  </label>
                  <!-- <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="$store.getters['common/getAllPORList']"
                    v-model="leadForm.lead_por_exp"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POR"
                  ></model-list-select>-->
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_por_exp"
                    name="lead_por_exp"
                    v-model="leadForm.lead_por_exp"
                    placeholder="Please Enter Exp POR"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_por_exp">
                    {{ errorList.lead_por_exp }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Exp/Imp POL
                    <span class="error"></span>
                  </label>
                  <!-- <model-list-select
                    @input="getLocationList($event, 'All', 'PortLoadList')"
                    @searchchange="getLocationList($event, 'All', 'PortLoadList')"
                    :list="$store.getters['common/getAllPOLList']"
                    v-model="leadForm.lead_pol_exp"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POL"
                  ></model-list-select>-->
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_pol_exp"
                    name="lead_pol_exp"
                    v-model="leadForm.lead_pol_exp"
                    placeholder="Please Enter Exp POL"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_pol_exp">
                    {{ errorList.lead_pol_exp }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Exp/Imp POD
                    <span class="error"></span>
                  </label>
                  <!-- <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="$store.getters['common/getAllPODList']"
                    v-model="leadForm.lead_pod_exp"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POD"
                  ></model-list-select>-->
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_pod_exp"
                    name="lead_pod_exp"
                    v-model="leadForm.lead_pod_exp"
                    placeholder="Please Enter Exp POD"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_pod_exp">
                    {{ errorList.lead_pod_exp }}
                  </span>
                </b-col>

                <!-- <b-col md="3">
                  <label>
                    Imp POR
                    <span class="error"></span>
                </label>-->
                <!-- <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                    :list="$store.getters['common/getAllPORList']"
                    v-model="leadForm.lead_por_imp"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POR"
                ></model-list-select>-->
                <!-- <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_por_imp"
                    name="lead_por_imp"
                    v-model="leadForm.lead_por_imp"
                    placeholder="Please Enter Imp POR"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_por_imp">
                    {{
                    errorList.lead_por_imp
                    }}
                  </span>
                </b-col>-->

                <!-- <b-col md="3">
                  <label>
                    Imp POL
                    <span class="error"></span>
                </label>-->
                <!-- <model-list-select
                    @input="getLocationList($event, 'All', 'PortLoadList')"
                    @searchchange="getLocationList($event, 'All', 'PortLoadList')"
                    :list="$store.getters['common/getAllPOLList']"
                    v-model="leadForm.lead_pol_imp"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POL"
                ></model-list-select>-->
                <!-- <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_pol_imp"
                    name="lead_pol_imp"
                    v-model="leadForm.lead_pol_imp"
                    placeholder="Please Enter Imp POL"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_pol_imp">
                    {{
                    errorList.lead_pol_imp
                    }}
                  </span>
                </b-col>-->

                <!-- <b-col md="3">
                  <label>
                    Imp POD
                    <span class="error"></span>
                </label>-->
                <!-- <model-list-select
                    @input="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                    :list="$store.getters['common/getAllPODList']"
                    v-model="leadForm.lead_pod_imp"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select POD"
                ></model-list-select>-->
                <!-- <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_pod_imp"
                    name="lead_pod_imp"
                    v-model="leadForm.lead_pod_imp"
                    placeholder="Please Enter Imp POD"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_pod_imp">
                    {{
                    errorList.lead_pod_imp
                    }}
                  </span>
                </b-col>-->

                <b-col md="3">
                  <label>
                    Interest Level
                    <span class="error"></span>
                  </label>
                  <model-list-select
                    :list="interestList"
                    id="lead_interest"
                    v-model="leadForm.lead_interest"
                    option-value="value"
                    option-text="text"
                    placeholder="Select Interest Level"
                  ></model-list-select>
                  <span class="error" v-if="!leadForm.lead_interest">
                    {{ errorList.lead_interest }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Source Type
                    <span class="error">*</span>
                  </label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="lead_source_type"
                    name="lead_source_type"
                    v-model="leadForm.lead_source_type"
                    placeholder="Please Enter Source Type"
                    type="text"
                  ></b-form-input>
                  <span class="error" v-if="!leadForm.lead_source_type">
                    {{ errorList.lead_source_type }}
                  </span>
                </b-col>
                <hr />
                <!-- <b-col md="3"></b-col> -->
                <!-- <b-col md="2" class="mt-4 text-center">
                  <b-button
                    size="sm"
                    class="pull-right"
                    style="margin:left:5px"
                    variant="primary"
                    @click="addLeadForm"
                  >Save</b-button>
                </b-col>
                <b-col md="3"></b-col>-->
              </md-layout>
            </div>
            <div>
              <b-col md="3"></b-col>
              <b-col md="3">
                <b-button
                  size="sm"
                  class="pull-right"
                  style="margin:left:5px"
                  variant="primary"
                  @click="addLeadForm"
                  >Save</b-button
                >

                <b-button
                  v-if="leadForm.lead_id"
                  variant="outline-primary"
                  style="font-size: 0.675rem"
                  @click="SendLead(row2.item)"
                  id="addButtonLoader"
                  size="sm"
                  >Send to Profile</b-button
                >
              </b-col>
              <b-col md="3"></b-col>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <!-- Client List Modal Added By Shreshth Gahlot Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="ClientList-modal"
      hide-footer
      title="Exits Client List"
    >
      <b-table
        show-empty
        stacked="md"
        :items="Exists_Client_data"
        responsive
        :fields="ClientListColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        class="position-relative"
      >
        <template slot="clientId" slot-scope="row0">
          <span>
            {{ row0.index + 1 + (currentPage - 1) * perPage }}
          </span>
        </template>
        <template slot="clientName" slot-scope="row1">
          <span>{{ row1.item.clientName != "" ? row1.item.clientName : "--" }}</span>
        </template>
      </b-table>
      <b-row>
        <b-col class="my-3 text-center">
          <b-button
            variant="outline-danger"
            class="ml-2"
            size="sm"
            @click="hideClientList"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <!-- Document Type Modal Added By Shreshth Gahlot End -->

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script src="https://unpkg.com/vue/dist/vue.js"></script>
<script src="https://unpkg.com/vue2-editor/dist/vue2-editor.umd.min.js"></script>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
import CommonService from "../../services/CommonService.js";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("edit_lead_id") != undefined &&
      this.$sessionsStorage.get("edit_lead_id") != null &&
      this.$sessionsStorage.get("edit_lead_id") != ""
    ) {
      // alert(this.$sessionsStorage.get("edit_lead_id"))
      this.getSingleLead(this.$sessionsStorage.get("edit_lead_id"));
    }
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );

    this.$store.dispatch(
      "common/setAllAirLineList",
      JSON.stringify({
        itemCode: "AirLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
        type: "Normal",
        Territory: "",
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );

    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    if (globalPermissionStatus("Lead")) {
      this.$store.dispatch("setCurrentRoute", "/lead/upsertLead");
      // this.getSingleLead();
      this.windowSize = $(window).width();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    AutoContainerType: {
      handler: function (newVal, oldVal) {
        this.masterCallbackContainer(newVal);
      },
      deep: true,
    },
  },
  data() {
    return {
      AddressArr: [],
      multiLeadArr: [
        {
          lead_name: "",
          lead_email: "",
          lead_mobile: "",
          lead_account: "",
          lead_name_err: "",
          lead_email_err: "",
          lead_mobile_err: "",
          lead_account_err: "",
        },
      ],
      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea",
        },
        {
          text: "Air",
          value: "Air",
        },
      ],
      moduelTypeList: [
        {
          text: "Export",
          value: "Export",
        },
        {
          text: "Import",
          value: "Import",
        },
      ],
      moduelTypeLeadList: [
        {
          text: "Export",
          value: "Export",
        },
        {
          text: "Import",
          value: "Import",
        },
        {
          text: "Both",
          value: "Both",
        },
      ],
      jobTypeList: [
        {
          text: "FF",
          value: "FF",
        },
        {
          text: "CC",
          value: "CC",
        },
        {
          text: "TPT",
          value: "TPT",
        },
      ],
      interestList: [
        {
          text: "Super Hot",
          value: "Super Hot",
        },
        {
          text: "Very Hot",
          value: "Very Hot",
        },
        {
          text: "Hot",
          value: "Hot",
        },
        {
          text: "Warm",
          value: "Warm",
        },
        {
          text: "Lukewarm",
          value: "Lukewarm",
        },
        {
          text: "Cold",
          value: "Cold",
        },
        {
          text: "Very Cold",
          value: "Very Cold",
        },
      ],
      TypeList: [
        {
          text: "Client",
          value: "1",
        },
        {
          text: "Lead",
          value: "2",
        },
        {
          text: "Overseas Agent",
          value: "3",
        },
      ],
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      ClientListColumns: [
        {
          key: "clientId",
          label: "SN",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      sortDirection: "desc",
      sortBy: null,
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      shipType_items: [],
      jobType_items: [],
      moduelType_items: [],
      shipmentType_items: [],
      Exists_Client_data: [],
      // shipmentType_items:[],
      accountList: [
        {
          text: "SALES",
          value: "SALES",
        },
        {
          text: "LOGISTICS OPERATIONS",
          value: "LOGISTICS OPERATIONS",
        },
        {
          text: "ACCOUNTS",
          value: "ACCOUNTS",
        },
        {
          text: "OWNER",
          value: "OWNER",
        },
        {
          text: "DIRECTOR",
          value: "DIRECTOR",
        },
        {
          text: "CFO",
          value: "CFO",
        },
        {
          text: "COO",
          value: "COO",
        },
        {
          text: "CEO",
          value: "CEO",
        },
        {
          text: "MANAGER",
          value: "MANAGER",
        },
        {
          text: "ASST. MANAGER",
          value: "ASST. MANAGER",
        },
      ],
      FFNAReasonList: [
        {
          val: "1",
          text: "ALL NOMINATION",
        },
        {
          val: "2",
          text: "ALL DIRECT SLINE CONTRACTS",
        },
      ],

      FFList: [
        {
          val: "1",
          text: "Yes",
        },
        {
          val: "0",
          text: "No",
        },
      ],

      CCList: [
        {
          val: "1",
          text: "Yes",
        },
        {
          val: "0",
          text: "No",
        },
      ],
      AutoContainerType: {},
      leadForm: {
        lead_id: "",
        lead_type: "2",
        lead_shipmentType: "",
        lead_moduelType: "",
        lead_jobType: "",
        lead_comp_name: "",
        // lead_name: "",
        // lead_email: "",
        // lead_mobile: "",
        lead_address: "",
        // lead_branch_address: [],
        // lead_factory_address: [],
        // lead_account: "",
        lead_container_type: [],
        lead_container_typeId: [],
        lead_comodity_exp: "",
        lead_comodity_imp: "",
        lead_pod_exp: "",
        lead_por_exp: "",
        lead_pol_exp: "",
        lead_pod_imp: "",
        lead_por_imp: "",
        lead_pol_imp: "",
        lead_exp_monthly_vol: "",
        lead_imp_monthly_vol: "",
        lead_sline: "",
        lead_remark: "",
        lead_source_type: "",
        lead_interest: "",
        is_active: true,

        // New questionnaire fields
        quest_cont_type_id: "",
        quest_export_import: "",
        quest_cc: null,
        quest_ff: null,
        quest_monthly_volume: "",
        quest_ff_option: "",
      },
      leadFormError: [
        "Please Select Lead Type",
        "Please Select Shipment Type",
        "Please Select Moduel Type",
        "Please Select Job Type",
        "Please Enter Company Name",
        // "Please Enter Lead Name",
        // "Please Enter Lead Email",
        // "Please Enter Lead Mobile",
        "Please Enter Lead Address",
        // "Please Select Account",
        // "Please Select Container Type",

        // New questionnaire error fields
        "This exportImport field is required.",
        "This cc field is required.",
        "This ff field is required.",
        "This Monthly Volume field is required.",
        "This FF Optionfield is required.",
      ],
      errorList: {
        lead_type: "",
        lead_shipmentType: "",
        lead_moduelType: "",
        lead_jobType: "",
        lead_comp_name: "",
        // lead_name: "",
        // lead_email: "",
        // lead_mobile: "",
        lead_address: "",
        // lead_account: "",
        // lead_container_type: "",

        // New questionnaire fields
        // quest_export_import: "",
        // quest_cont_type_id: "",
        // quest_cc: "",
        // quest_ff: "",
        // quest_monthly_volume: "",
        // quest_ff_option: "",
      },
      selectDateFormat,

      AutoContainerType: {},

      isLoading: false,
      validate: false,

      ContainerError: ["Please Select Container", "Please Enter No of Container"],
      containererrorList: {
        containerTypeId: "",
        noOfContainer: "",
      },
      docURL: URL_BASE_DOC,
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect,
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {
    disbleLead() {
      return this.leadForm.lead_id != "" ? true : false;
    },
    isSeaShipment() {
      // Check if lead_shipmentType is an array and contains an object with value 'Sea'
      return (
        Array.isArray(this.shipmentType_items) &&
        this.shipmentType_items.some((item) => item.value === "Sea")
      );
    },
  },
  methods: {
    goBack() {
      window.history.go(-1);
    },
    setLeadDetails(item, lead_id) {
      if (lead_id != undefined && lead_id != null && lead_id != "") {
        let lead_details = item;
        console.log("lead_details", lead_details);
        this.AddressArr = [];
        this.multiLeadArr = [];
        let moduelType = item.lead_moduelType.split(",");
        let jobType = item.lead_jobType.split(",");
        let shipmentType = item.lead_shipmentType.split(",");
        moduelType.forEach((mval, mkey) => {
          let mObj = {
            text: mval,
            value: mval,
          };
          this.moduelType_items.push(mObj);
        });
        jobType.forEach((jval, jkey) => {
          let jObj = {
            text: jval,
            value: jval,
          };
          this.jobType_items.push(jObj);
        });
        shipmentType.forEach((sval, skey) => {
          let sObj = {
            text: sval,
            value: sval,
          };
          this.shipmentType_items.push(sObj);
        });
        let lead_container_type = [];
        let lead_container_typeId = [];
        if (
          lead_details.lead_container_type != undefined &&
          lead_details.lead_container_type != null &&
          lead_details.lead_container_type != ""
        ) {
          lead_container_type = lead_details.lead_container_type.split(",");
          lead_container_typeId = lead_details.lead_container_typeId.split(",");
        }
        this.leadForm = {
          lead_id: lead_details.lead_id,
          lead_type: lead_details.lead_type,
          lead_shipmentType: lead_details.lead_shipmentType,
          lead_moduelType: lead_details.lead_moduelType,
          lead_jobType: lead_details.lead_jobType,
          lead_comp_name: lead_details.lead_comp_name,
          lead_name: lead_details.lead_name,
          lead_email: lead_details.lead_email,
          lead_mobile: lead_details.lead_mobile,
          lead_address: lead_details.lead_address,
          lead_account: lead_details.lead_account,
          lead_container_type: lead_container_type,
          lead_container_typeId: lead_container_typeId,
          // lead_container_typeId: (lead_details.lead_container_typeId).split(","),
          lead_comodity_exp: lead_details.lead_comodity_exp,
          lead_comodity_imp: lead_details.lead_comodity_imp,
          lead_pod_exp: lead_details.lead_pod_exp,
          lead_por_exp: lead_details.lead_por_exp,
          lead_pol_exp: lead_details.lead_pol_exp,
          lead_pod_imp: lead_details.lead_pod_imp,
          lead_por_imp: lead_details.lead_por_imp,
          lead_pol_imp: lead_details.lead_pol_imp,
          lead_exp_monthly_vol: lead_details.lead_exp_monthly_vol,
          lead_imp_monthly_vol: lead_details.lead_imp_monthly_vol,
          lead_sline: lead_details.lead_sline,
          lead_remark: lead_details.lead_remark,
          lead_source_type: lead_details.lead_source_type,
          lead_interest: lead_details.lead_interest,
          is_active: true,

          quest_cont_type_id: lead_details.lead_interest,
          quest_export_import: lead_details.quest_export_import,
          quest_cc: lead_details.quest_cc,
          quest_ff: lead_details.quest_ff,
          quest_monthly_volume: lead_details.quest_monthly_volume,
          quest_ff_option: lead_details.quest_ff_option,
        };

        if (
          lead_details.multi_address != undefined &&
          lead_details.multi_address != null &&
          lead_details.multi_address != ""
        ) {
          this.AddressArr = JSON.parse(lead_details.multi_address);
        }
        if (
          lead_details.lead_details != undefined &&
          lead_details.lead_details != null &&
          lead_details.lead_details != ""
        ) {
          this.multiLeadArr = JSON.parse(lead_details.lead_details);
        }
      } else {
        this.leadForm = {
          lead_id: "",
          lead_type: "2",
          lead_shipmentType: "",
          lead_moduelType: "",
          lead_jobType: "",
          lead_comp_name: "",
          // lead_name: "",
          // lead_email: "",
          // lead_mobile: "",
          lead_address: "",
          // lead_branch_address: [],
          // lead_factory_address: [],
          // lead_account: "",
          lead_container_type: [],
          lead_container_typeId: [],
          lead_comodity_exp: "",
          lead_comodity_imp: "",
          lead_pod_exp: "",
          lead_por_exp: "",
          lead_pol_exp: "",
          lead_pod_imp: "",
          lead_por_imp: "",
          lead_pol_imp: "",
          lead_exp_monthly_vol: "",
          lead_imp_monthly_vol: "",
          lead_sline: "",
          lead_remark: "",
          lead_source_type: "",
          lead_interest: "",
          is_active: true,

          quest_cont_type_id: "",
          quest_export_import: "",
          quest_cc: "",
          quest_ff: "",
          quest_monthly_volume: "",
          quest_ff_option: "",
        };
      }
    },
    addMultiAddress() {
      let obj = {
        branch_address: "",
        factory_address: "",
        branch_address_err: "",
        factory_address_err: "",
      };
      this.AddressArr.push(obj);
    },
    removeMultiAddress(index) {
      this.AddressArr.splice(index, 1);
    },

    addMultiLead() {
      let obj = {
        lead_name: "",
        lead_email: "",
        lead_mobile: "",
        lead_account: "",
        lead_name_err: "",
        lead_email_err: "",
        lead_mobile_err: "",
        lead_account_err: "",
      };
      this.multiLeadArr.push(obj);
    },
    removeMultiLead(index) {
      this.multiLeadArr.splice(index, 1);
    },

    SelectMultijobType(jobType_items, lastSelectItem) {
      this.jobType_items = jobType_items;
      this.leadForm.lead_jobType = jobType_items;
    },
    SelectMultimoduelType(moduelType_items, lastSelectItem) {
      this.moduelType_items = moduelType_items;
      this.leadForm.lead_moduelType = moduelType_items;
    },
    SelectMultishipmentTypeType(shipmentType_items, lastSelectItem) {
      this.shipmentType_items = shipmentType_items;
      this.leadForm.lead_shipmentType = shipmentType_items;
    },

    deleteContainer(item) {
      let i = this.ffExoprtDetail.lead_container_type.indexOf(item);

      this.ffExoprtDetail.lead_container_type.splice(i, 1);
      this.ffExoprtDetail.lead_container_typeId.splice(i, 1);
    },
    masterCallbackContainer(item) {
      if (this.leadForm.lead_container_type.length > 0) {
        let i = this.leadForm.lead_container_type.indexOf(item.containerType);

        if (i < 0) {
          this.leadForm.lead_container_type.push(item.containerType);
          this.leadForm.lead_container_typeId.push(item.containerTypeId);
        }
      } else {
        this.leadForm.lead_container_type.push(item.containerType);
        this.leadForm.lead_container_typeId.push(item.containerTypeId);
      }
      console.log(this.leadForm.lead_container_type);
      console.log(this.leadForm.lead_container_typeId);
    },
    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    validateLeads() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        // if (
        //   this.leadForm[x] == "" ||
        //   this.leadForm[x] == undefined ||
        //   this.leadForm[x] == null
        // ) {
        //   this.errorList[x] = this.leadFormError[index];
        //   validate_new = false;
        // }
        if (
          (x.startsWith("quest_") && !this.isSeaShipmentCheck()) ||
          this.leadForm[x] === "" ||
          this.leadForm[x] === undefined ||
          this.leadForm[x] === null ||
          (Array.isArray(this.leadForm[x]) && this.leadForm[x].length === 0)
        ) {
          this.errorList[x] = this.leadFormError[index];
          validate_new = false;
        } else {
          this.errorList[x] = ""; // Clear previous error message
        }
      });

      // Specific validation for questionnaire fields
      console.log(
        "Array.isArray(this.leadForm.lead_shipmentType)=>",
        this.isSeaShipmentCheck(),
        this.leadForm.lead_shipmentType
      );
      if (this.isSeaShipmentCheck()) {
        // alert(this.isSeaShipmentCheck());
        if (!this.leadForm.quest_export_import) {
          this.errorList.quest_export_import = this.leadFormError[6];
          validate_new = false;
        }

        if (this.leadForm.quest_cc === null) {
          this.errorList.quest_cc = this.leadFormError[7];
          validate_new = false;
        }

        if (this.leadForm.quest_ff === null) {
          this.errorList.quest_ff = this.leadFormError[8];
          validate_new = false;
        }

        if (this.leadForm.quest_ff === "Yes" && !this.leadForm.quest_monthly_volume) {
          this.errorList.quest_monthly_volume = this.leadFormError[9];
          validate_new = false;
        }

        if (this.leadForm.quest_ff === "No" && !this.leadForm.quest_ff_option) {
          this.errorList.quest_ff_option = this.leadFormError[10];
          validate_new = false;
        }
      }
      console.log("this.errorList=>", this.errorList);

      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    isSeaShipmentCheck() {
      // Check if lead_shipmentType is an array and contains an object with value 'Sea'
      const isSea =
        Array.isArray(this.shipmentType_items) &&
        this.shipmentType_items.some((item) => item.value === "Sea");
      let isSeaFlag = isSea ? true : false;
      return isSeaFlag; // Explicitly return true or false
    },

    validateFFContainer() {
      let validate_new = true;

      if (this.containerModal.containerTypeId == "") {
        $("#containerTypeId").focus();
        this.containerTypeIdError = "Select Container Type";
        validate_new = false;
      }
      if (this.containerModal.noOfContainer == "") {
        $("#noOfContainer").focus();
        this.noOfContainerError = "Enter No of Container";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    validateAddressDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.AddressArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].branch_address == "") {
          this.AddressArr[j].branch_address_err =
            "Branch Address " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.AddressArr[j].branch_address_err = "";
          validate_new = true;
        }

        if (MainARR[j].factory_address == "") {
          this.AddressArr[j].factory_address_err =
            "Factory Address " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.AddressArr[j].factory_address_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateLeadDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.multiLeadArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].lead_account == "") {
          this.multiLeadArr[j].lead_account_err =
            "Account " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.multiLeadArr[j].lead_account_err = "";
          validate_new = true;
        }

        if (MainARR[j].lead_name == "") {
          this.multiLeadArr[j].lead_name_err =
            "Name " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.multiLeadArr[j].lead_name_err = "";
          validate_new = true;
        }

        if (MainARR[j].lead_email == "") {
          this.multiLeadArr[j].lead_email_err =
            "Email ID " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.multiLeadArr[j].lead_email_err = "";
          validate_new = true;
        }

        if (MainARR[j].lead_mobile == "") {
          this.multiLeadArr[j].lead_mobile_err =
            "Mobile No " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.multiLeadArr[j].lead_mobile_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addLeadForm() {
      this.validateLeads();
      this.validateLeadDetail();
      this.leadForm.lead_moduelType = "";
      this.leadForm.lead_jobType = "";
      this.leadForm.lead_shipmentType = "";
      if (!this.leadForm.lead_moduelType) {
        this.leadForm.lead_moduelType = "";
        this.moduelType_items.forEach((item_val) => {
          if (this.leadForm.lead_moduelType) {
            this.leadForm.lead_moduelType =
              this.leadForm.lead_moduelType + "," + item_val.value;
          } else {
            this.leadForm.lead_moduelType = item_val.value;
          }
        });
      }

      if (!this.leadForm.lead_jobType) {
        this.leadForm.lead_jobType = "";
        this.jobType_items.forEach((item_val) => {
          if (this.leadForm.lead_jobType) {
            this.leadForm.lead_jobType =
              this.leadForm.lead_jobType + "," + item_val.value;
          } else {
            this.leadForm.lead_jobType = item_val.value;
          }
        });
      }

      if (!this.leadForm.lead_shipmentType) {
        this.leadForm.lead_shipmentType = "";
        this.shipmentType_items.forEach((item_val) => {
          if (this.leadForm.lead_shipmentType) {
            this.leadForm.lead_shipmentType =
              this.leadForm.lead_shipmentType + "," + item_val.value;
          } else {
            this.leadForm.lead_shipmentType = item_val.value;
          }
        });
      }
      console.log("leadForm=>", this.leadForm);
      console.log("errorList=>", this.errorList);
      // this.validateAddressDetail();
    
      // this.leadForm.AddressArr = JSON.stringify(this.AddressArr);
      this.leadForm.TypeofAdd = "Lead Master Add";
      if (this.validate == false) return false;
      this.leadForm.AddressArr = JSON.stringify(this.AddressArr);
      this.leadForm.lead_details = JSON.stringify(this.multiLeadArr);
      this.isLoading = true;
      let payload = {
        itemCode: "add_Lead_Details",
        leadForm: this.leadForm,
      };
      // console.log("payload=>", payload);
      // return false;
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        LeadService.getAllLeadList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.lead_id != "" && data.lead_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              if (data.flag == true) {
                this.$router.push({
                  path: "/lead/leadlist",
                });
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    SendLead(item) {
      if (item.lead_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "Send_Lead_Mail",
          leadForm: item,
        };
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          LeadService.getAllLeadList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              if (data.lead_id != "" && data.lead_id != undefined) {
                if (data.find == 1 || data.find == 2) {
                  this.alert.content = data.MSG;
                } else {
                  this.alert.content = data.MSG;
                }
                if (data.flag == true) {
                  this.$router.push({
                    path: "/lead/leadlist",
                  });
                }
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
            })
            .catch((error) => {
              console.log("Catch on Proforma Error: ", error);
            });
        }
      }
    },

    getSingleLead(id) {
      this.isLoading = true;
      let payload = {
        itemCode: "Single_Leads",
        lead_id: id,
      };
      LeadService.getAllLeadList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            // this.leadForm = data.singleLead;
            this.setLeadDetails(data.singleLead, data.singleLead.lead_id);
            console.log(" Single Lead response=>", data);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Lead Error: ", error);
        });
    },

    previousFFView() {
      k;
      window.history.go(-1);
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    //Shreshth Gahlot Function START HERE
    CheckClientName(clientName) {
      //alert(clientName.length);
      if (clientName.length > 2) {
        let payload = {
          itemCode: "Client_List_details",
          ClientName: clientName,
        };
        CommonService.getAllCommonMaster(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.length > 0) {
                this.Exists_Client_data = data.Exists_Client_data;
                console.log("Check Client Name response=>", data);
                this.$refs["ClientList-modal"].show();
              }
            }

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on Check Client Name Error: ", error);
          });
      }
    },
    //Shreshth Gahlot Function END HERE
    hideClientList() {
      this.$refs["ClientList-modal"].hide();
      $("#lead_comp_name").focus();
    },
  },
};
</script>
<style scoped>
.quotePMargin {
  margin: 0px;
  text-align: left !important;
}
.md-direction-bottom-right {
  width: 18% !important;
}

.md-flex-xsmall-100 {
  min-width: 100%;

  flex: 0 1 100%;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// upsertLead.vue?35d3aa41